module.exports = __webpack_public_path__ + "img/bg-s.e5bfce35.png";